import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
        margin-left: 15px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 10px;
                        width: 100%;
                    `,
                    css`
                        margin-left: 7px;
                        width: initial;
                    `,
                    css`
                        margin-left: 7px;
                    `,
                ],
                "minMax",
            )}
    `,
};
